import React, { useState, useEffect } from "react";
import {
  ArrowRight,
  Shield,
  CheckCircle,
  Smartphone,
  Globe,
  CreditCard,
  QrCode,
  Star,
  Users,
  TrendingUp,
  Zap,
  Headphones,
  ChevronDown,
  Menu,
  X,
  Clock,
  Wifi,
  Lock,
  Building2,
  MousePointer,
  ArrowLeftRight,
  Activity,
  BarChart3,
  Bell,
  Video,
  Eye,
  Settings,
  Database,
  Cpu,
  FileText,
  Play,
  Mail,
  BarChart,
  ShoppingCart,
  Brain,
  Phone,
  Target,
  MessageSquare,
  UserCheck,
  DollarSign,
  Coins,
  Banknote
} from "lucide-react";
import Header from "./header";
import Footer from "./footer";
import HeroSlider from "./slider";

const BusinessLanding = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Add smooth scroll styles
  useEffect(() => {
    const smoothScrollStyles = `
      html {
        scroll-behavior: smooth;
      }
      
      @media (prefers-reduced-motion: no-preference) {
        html {
          scroll-behavior: smooth;
        }
      }
    `;
    
    const styleSheet = document.createElement('style');
    styleSheet.innerText = smoothScrollStyles;
    document.head.appendChild(styleSheet);
    
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  // Smooth scroll function
  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  const walletCards = [
    {
      icon: <CreditCard className="w-12 h-12 text-white" />,
      title: "Payin Solution",
      description: "Seamless deposit functionality with multiple payment methods",
      color: "from-blue-500 to-cyan-600",
      bgColor: "bg-gradient-to-br from-blue-50 to-cyan-50",
      features: [
        "Multiple payment gateways",
        "Real-time transaction processing",
        "Instant notifications",
        "Secure payment handling"
      ]
    },
    {
      icon: <Banknote className="w-12 h-12 text-white" />,
      title: "Payout Solution",
      description: "Quick and secure withdrawal options for users",
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
      features: [
        "Instant payouts",
        "Multiple withdrawal methods",
        "Automated processing",
        "Fraud protection"
      ]
    },
    {
      icon: <Smartphone className="w-12 h-12 text-white" />,
      title: "NETC Acquirer",
      description: "Comprehensive acquirer management and operations",
      color: "from-purple-500 to-indigo-600",
      bgColor: "bg-gradient-to-br from-purple-50 to-indigo-50",
      features: [
        "Transaction routing",
        "Merchant management",
        "Real-time monitoring",
        "Settlement processing"
      ]
    },
    {
      icon: <FileText className="w-12 h-12 text-white" />,
      title: "NETC Issuer",
      description: "Detailed issuing and transaction processing",
      color: "from-rose-500 to-pink-600",
      bgColor: "bg-gradient-to-br from-rose-50 to-pink-50",
      features: [
        "Card issuance",
        "Transaction authorization",
        "Account management",
        "Reporting & analytics"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <Header />  
      {/* <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Seamless Banking
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                  Solutions
                </span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Elevate Your Business with Our Cutting-Edge Banking
                Services for Secure and Effortless Transactions
              </p>
              
               <div className="space-y-4 mb-8">
                {[
                  { icon: <Shield className="w-5 h-5" />, text: "Bank-grade security" },
                  { icon: <Zap className="w-5 h-5" />, text: "Lightning-fast processing" },
                  { icon: <CheckCircle className="w-5 h-5" />, text: "99.9% uptime guarantee" }
                ].map((feature, index) => (
                  <div 
                    key={index}
                    className={`flex items-center space-x-3 transition-all duration-700 ${
                      isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
                    }`}
                    style={{ transitionDelay: `${index * 200}ms` }}
                  >
                    <div className="text-blue-600">{feature.icon}</div>
                    <span className="text-gray-700">{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="./banking.png"
                style={{ height: "350px!important" }}
                alt="Payment Gateway"
                className="w-full h-auto rounded-lg mb-6"
              />
            </div>
          </div>
        </div>
      </section> */}
<HeroSlider/>
      {/* Business Solutions - Dark */}
      <div className="bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Complete Business Solutions
            <br />
            for the Digital Age
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Payments, Ecommerce, Analytics, CRM, and FinTech - All in one platform
          </p>
          <div className="flex justify-center">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center" onClick={() => smoothScrollTo('gateway')}>
              <button 
                onClick={() => smoothScrollTo('gateway')}
                className="text-blue-600 hover:text-blue-800 transition-colors focus:outline-none"
              >
                <ArrowRight className="w-6 h-6 text-blue-600" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Gateway Solutions - Light */}
      <div id="gateway" className="scroll-mt-20">
        <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-purple-50 to-pink-100 relative overflow-hidden">
          {/* Animated Background Elements */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-purple-200 to-pink-300 rounded-full opacity-30 animate-bounce" style={{animationDuration: '3s'}}></div>
            <div className="absolute top-1/2 -left-20 w-32 h-32 bg-gradient-to-br from-blue-200 to-cyan-300 rounded-full opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
            <div className="absolute -bottom-20 right-1/3 w-36 h-36 bg-gradient-to-br from-emerald-200 to-teal-300 rounded-full opacity-30 animate-pulse" style={{animationDelay: '2s'}}></div>
          </div>

          <div className="max-w-7xl mx-auto relative">
            {/* Hero Section */}
            <div className={`flex flex-col lg:flex-row items-center gap-12 mb-16 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              {/* Left Side - Illustration */}
              <div className="lg:w-1/2 flex justify-center">
                <div className="relative">
                  <div className="w-80 h-96 bg-gradient-to-br from-indigo-600 to-purple-700 rounded-3xl transform rotate-6 animate-pulse shadow-2xl"></div>
                  <div className="absolute top-8 left-8 w-64 h-80 bg-gradient-to-br from-gray-100 to-white rounded-2xl shadow-xl">
                    <div className="p-6">
                      <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mb-4 animate-spin" style={{animationDuration: '3s'}}></div>
                      <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mb-4 animate-spin" style={{animationDuration: '3s', animationDelay: '0.5s'}}></div>
                      <div className="w-40 h-24 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg mt-8"></div>
                    </div>
                  </div>
                  <div className="absolute -bottom-4 -right-4 w-16 h-20 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-bounce"></div>
                </div>
              </div>

              {/* Right Side - Content */}
              <div className="lg:w-1/2 text-center lg:text-left">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Payment</span>{' '}
                  <span className="text-gray-800">Solutions</span>
                </h1>
                <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
                  Our Pay-in and Payout solutions provide businesses with a seamless, secure, and fully customizable payment infrastructure. 
                  Whether you need to collect funds from customers or disburse payments to vendors, our platform offers a comprehensive suite of features designed to enhance your financial operations.
                </p>
              </div>
            </div>

            {/* Features Header */}
            <div className={`text-center mb-12 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '300ms'}}>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="text-gray-700">Unveil the </span>{' '}
                <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">features</span>{' '}
              </h2>
            </div>

            {/* Wallet Cards Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
              {walletCards.map((card, index) => (
                <div 
                  key={index}
                  className={`${card.bgColor} rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-white/50 backdrop-blur-sm
                             transform hover:scale-105 hover:-translate-y-2 cursor-pointer group relative overflow-hidden
                             ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
                  style={{
                    transitionDelay: `${400 + index * 100}ms`
                  }}
                >
                  {/* Gradient overlay effect */}
                  <div className={`absolute inset-0 bg-gradient-to-r ${card.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
                  
                  <div className="relative z-10">
                    <div className="flex flex-col items-center text-center">
                      <div className={`mb-6 p-4 bg-gradient-to-r ${card.color} rounded-2xl shadow-lg transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3`}>
                        {card.icon}
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-4 group-hover:text-gray-900 transition-colors duration-300">
                        {card.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-sm group-hover:text-gray-700 transition-colors duration-300 mb-6">
                        {card.description}
                      </p>
                    </div>
                  </div>
                  
                  {/* Decorative corner element */}
                  <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${card.color} opacity-10 rounded-bl-full`}></div>
                </div>
              ))}
            </div>

            {/* Decorative Elements */}
            <div className={`flex justify-center mt-12 space-x-2 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '1000ms'}}>
              <div className="w-8 h-1 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full animate-pulse"></div>
              <div className="w-8 h-1 bg-gradient-to-r from-blue-400 to-cyan-500 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
              <div className="w-8 h-1 bg-gradient-to-r from-emerald-400 to-teal-500 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
            </div>
          </div>
        </section> 
      </div>

      {/* Video Technology Solutions - Dark */}
      <div className="py-20 px-4 bg-gradient-to-br from-gray-900 via-purple-900/30 to-indigo-900/30">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="bg-black/20 backdrop-blur-sm border border-white/10 rounded-xl p-8">
            <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-lg">
              <span className="text-purple-300">+</span> Video Technology Solutions
            </h2>
            <p className="text-xl text-gray-100 mb-8 font-medium drop-shadow-md">
              Comprehensive video communication solutions for seamless business operations with Secure and compliant digital identity verification:
            </p>
            <div className="space-y-4">
              {[
                "HD Video Conferencing",
                "Recording & Playback",
                "Enterprise Security",
                "API Integration",
                "Real-time Document Verification",
                "Call details Reporting",
                "Mobile & Web Compatible",
                "End-to-end Encryption",
              ].map((feature, index) => (
                <div key={index} className="flex items-center bg-white/5 rounded-lg p-3 border border-white/10">
                  <div className="w-3 h-3 bg-purple-400 rounded-full mr-4 shadow-lg"></div>
                  <span className="text-lg text-white font-medium drop-shadow-sm">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
             <div className="relative">
                <div className="w-full h-80 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-lg flex items-center justify-center">
                  <div className="text-white text-center">
                    <Video className="w-24 h-24 mx-auto mb-4" />
                    <div className="relative">
                      <img src="./video.png" alt="Video Technology" className="w-full h-auto rounded-lg" />
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
      {/* Why Choose Us - Light */}
      <div className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why choose us?
          </h2>

          <div className="grid md:grid-cols-5 gap-8 mt-16">
            {[
              {
                icon: <Shield className="w-8 h-8" />,
                title: "Secure",
                desc: "Enterprise-grade security for all your business data",
                color: "blue",
              },
              {
                icon: <CheckCircle className="w-8 h-8" />,
                title: "Compliant",
                desc: "Full regulatory compliance across all solutions",
                color: "green",
              },
              {
                icon: <TrendingUp className="w-8 h-8" />,
                title: "Scalable",
                desc: "Solutions that grow with your business needs",
                color: "purple",
              },
              {
                icon: <Headphones className="w-8 h-8" />,
                title: "24/7 Support",
                desc: "Round-the-clock expert assistance",
                color: "orange",
              },
              {
                icon: <Zap className="w-8 h-8" />,
                title: "API-Driven",
                desc: "Seamless integration with existing systems",
                color: "cyan",
              },
            ].map((feature, index) => (
              <div key={index} className="text-center">
                <div
                  className={`w-16 h-16 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-4`}
                >
                  <div className={`text-${feature.color}-600`}>
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-20 px-4 bg-gradient-to-r from-blue-600 to-purple-700">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl text-white mb-6">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Get started with our comprehensive suite of business solutions today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
             <a href="/Contact" className="flex items-center">
              <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
              Get Started →
            </button>
               {/* <Phone className="w-5 h-5 text-blue-600 mr-2" />
               <span className="text-blue-600">Contact Us</span> */}
             </a>
           
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BusinessLanding;